import { useState, useEffect } from "react";
import HeaderBar from "../HeaderBar";
import useStateMachineWrapper from "../../helpers/useStateMachineWrapper";

import { useForm } from "react-hook-form";
import useCalculators from "../../helpers/useCalculators";
import CartDetails from "../CartDetails";
import { dataLayerPush } from "../../helpers/analytics";
import SpeedDetails from "../SpeedDetails";
import PromoCodeInput from "../PromoCode";
import MobileNextButton from "../MobileNextButton";

const OrderSummary = (props) => {
  const {actions, state, sendState} = useStateMachineWrapper();

  const {getCartItems, getSubtotal} = useCalculators();

  const { control, register, handleSubmit, formState: { errors, isValid, submitCount } } = useForm({
    defaultValues: {
      tos: state.session.tos,
    },
  });

  const tosToggle = (e) => {
    if(e.target.checked) {
      dataLayerPush({
        'event' : 'tos_checked'
      });
    } else {
      dataLayerPush({
        'event' : 'tos_unchecked'
      });
    }

    actions.update({tos: e.target.checked ? 'Y' : ''});
  };

  return (<>
        {/* <Breadcrumbs /> */}

        <HeaderBar backPage={'choose-phone'} nextPage={'order-customer'} nextPageEnabled={state.session.tos === 'Y'} className="items-center">
          <h1 className="bigger">Order Summary</h1>
          <p>Please review the details of your order</p>
        </HeaderBar>

        <CartDetails/>
        {/* mx-auto inline-block */}
        <div className="px-6 text-left">
          <p className="font-bold">Contract Terms</p>
          <p>
            - No Contract
            <br/>
            - No Data Caps
            <br/>
            - Risk-Free 30-Day Money Back Guarantee
            <br/>
            * Taxes and other fees may apply
          </p>
        </div>
        <PromoCodeInput/>
        <div className="mt-4 text-lg font-bold">
        Total Due Prior to Installation: ${getSubtotal()}
        </div>

        <div className="mt-4">
          <label>
            <input type="checkbox" name="tos" id="tos" value="Y" checked={state.session.tos === 'Y'} {...register("tos", {required: true})} onChange={tosToggle} />
            <span className="ml-2">I acknowledge that I agree to the <a href="https://www.i3broadband.com/terms-of-service/" target="_blank" className="text-purple">Terms of Use</a> and have read the <a href="https://www.i3broadband.com/terms-of-service/" target="_blank" className="text-purple">Privacy Policy</a>.</span>
          </label>
        </div>
        {/* text-purple */}
        <div className="!mt-4"><SpeedDetails className="text-sm cursor-pointer inline" /></div>
        <HeaderBar backPage={'choose-phone'} nextPage={'order-customer'} nextPageEnabled={state.session.tos === 'Y'} className="items-center"></HeaderBar>
    </>)

};

export default OrderSummary;
